export default {"src":"/_next/static/media/agile-icon.29e2e671.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};